// import { notification } from "antd";

const PATHS = {
  baseURL: process.env.REACT_APP_API_ENDPOINT,

  appBaseUrl: "/api/v1",

  otpVerifyUrl: "/user/confirm-verify",

  otpRetryUrl: "/user/confirm-retry?",

  commonRegister: "/user/confirm-register",

  mediaService: {
    baseURL: "/medias/v1",
  },

  jobs: { baseUrl: "/jobs", myjobs: "/my-jobs", recruiterJobs: "/jobs/recruiter" },

  enumerator: {
    baseUrl: "/enumerator",
    login: "/signin",
    oauthGoogleLogin: "/signin/google",
    oauthFacebokleLogin: "/signin/facebook",
    forgotPassword: {
      requestOtp: "/forgot-password-request?isSendMail=false",
      verifyOtp: "/otp-verify",
      passwordSetup: "/forgot-password",
    },

    changePassword: {
      requestOtp: "/change-password-request?isSendMail=false",
      verifyOtp: "/otp-verify",
      passwordSetup: "change-password",
    },

    availability: "availability",
  },

  recruiter: {
    baseUrl: "/recruiter",
    login: "/signin",
    candidates: "/candidates",
    oauthGoogleLogin: "/signin/google",
    oauthFacebokleLogin: "/signin/facebook",
    activity: "/activities?userType=Recruiter",
    forgotPassword: {
      requestOtp: "/forgot-password-request?isSendMail=false",
      verifyOtp: "/otp-verify",
      passwordSetup: "/forgot-password",
    },

    changePassword: {
      requestOtp: "/change-password-request?isSendMail=false",
      verifyOtp: "/otp-verify",
      passwordSetup: "change-password",
    },
  },

  socket: {
    notification: "/ws/v1/bell-notification",
    message: "/ws/v1/room-message",
  },

  notificationService: {
    baseURL: "/notifications",
    archive: "/archive",
  },
};

export default PATHS;
